import React, { Component } from 'react';
import { Table, ButtonToolbar, Grid, Row, Col } from 'react-bootstrap';

import { DownloadCommand } from './commands/DownloadCommand';
import { PaginationBuilder } from '../PaginationBuilder';
import { PaginationHelper } from '../helpers/PaginationHelper';
import { LoadingSpinner } from '../LoadingSpinner';
import { HandleMessage } from '../HandleMessage';
import { TableButton } from '../TableButton';
import { SortIndicator } from '../SortIndicator';

export class LayoutsTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sort: {
                property: 'name',
                type: 'ascending'
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            commands: {
                downloadCommand: new DownloadCommand(props.appName)
            }
        };
    }

    onChangeSort(property) {
        const { sort } = this.state;
        this.setState({
            sort: {
                property: property,
                type: sort.property === property && sort.type === 'ascending' ? 'descending' : 'ascending'
            }
        });
    }

    renderSortIndicator(property) {
        const { sort } = this.state;
        return <SortIndicator order={sort.property === property ? sort.type : 'none'} />;
    }

    sortLayouts(a, b) {
        const { sort } = this.state;
        const aValue = a[sort.property] || '';
        const bValue = b[sort.property] || '';
        const output = aValue < bValue ? -1 : 1;
        return sort.type === 'descending' ? output * -1 : output;
    }

    onDownloadLayout(layout) {
        const { commands } = this.state;

        commands.downloadCommand.downloadLayout(
            layout,
            (a, b) => this.saveAs(a, b),
            (a) => this.errorCallback(a)
        );
    }

    saveAs(blob, fileName) {
        var FileSaver = require('file-saver');
        FileSaver.saveAs(blob, fileName);
    }

    errorCallback(errorMessage) {
        this.setState({
            message: {
                show: true,
                message: errorMessage,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        });
    }

    render() {
        const { isLoading } = this.props;
        if (isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        const { data, page, elementsPerPage } = this.props.table;
        const { message } = this.state;
        const selectedLayoutIds = this.props.selectedLayoutIds;
        const onRowClick = this.props.onRowClick;
        const onDragStart = this.props.onDragStart;
        const onCopyLayout = this.props.onCopyLayout;
        const onEditLayout = this.props.onEditLayout;
        const onDeleteLayout = this.props.onDeleteLayout;
        var self = this;

        const dataSorted = data.slice().sort(function(a, b) { return self.sortLayouts(a, b); });
        const totalPages = PaginationHelper.getTotalPages(dataSorted.length, elementsPerPage);
        const activePage = totalPages < page ? totalPages : page;
        const partialData = dataSorted.slice((activePage - 1) * elementsPerPage, activePage * elementsPerPage);

        return (
            <Grid fluid>
                <Row>
                    <Col sm={12}>
                        <Table responsive striped hover className="margin-top-10">
                            <thead>
                                <tr>
                                    <th className="sortable width-60p" onClick={() => this.onChangeSort('name')}>Nome {this.renderSortIndicator('name')}</th>
                                    <th className="width-20p">Formato</th>
                                    <th className="width-20p">Orientação</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    partialData.map(function(layout, idx) {
                                        var isSelected = selectedLayoutIds && selectedLayoutIds.has(layout.id);
                                        return (
                                            <tr
                                                key={'layout-' + idx}
                                                className={'busched selectable' + (isSelected ? ' checked' : '')}
                                                draggable={true}
                                                onClick={function() { onRowClick && onRowClick(layout); }}
                                                onDragStart={function(e) { onDragStart && onDragStart(e, layout); }}
                                            >
                                                <td>{layout.name}</td>
                                                <td>{layout.format}</td>
                                                <td>{layout.orientation}</td>
                                                <td>
                                                    <ButtonToolbar style={{ display: "flex" }}>
                                                        <TableButton marginRight icon="icon-copy" title="Copiar" onClick={function(e) { e.stopPropagation(); onCopyLayout && onCopyLayout(layout); }} />
                                                        <TableButton marginRight icon="icon-download" title="Download" onClick={function(e) { e.stopPropagation(); self.onDownloadLayout(layout); }} />
                                                        <TableButton marginRight icon="icon-edit" title="Editar" onClick={function(e) { e.stopPropagation(); onEditLayout && onEditLayout(layout); }} />
                                                        <TableButton icon="icon-trash" title="Eliminar" onClick={function(e) { e.stopPropagation(); onDeleteLayout && onDeleteLayout(layout); }} />
                                                    </ButtonToolbar>
                                                </td>
                                            </tr>
                                        );
                                    })
                                }
                            </tbody>
                        </Table>

                        <PaginationBuilder
                            currentPage={page}
                            elementsPerPage={elementsPerPage}
                            dataLength={dataSorted.length}
                            onChangePage={this.props.onChangePage}
                            onChangeElementsPerPage={this.props.onChangeElementsPerPage} />

                        <HandleMessage
                            title={message.title}
                            message={message.message}
                            style={message.style}
                            icon={message.icon}
                            show={message.show}
                            onHide={() => this.onExitMessage()} />
                    </Col>
                </Row>
            </Grid>
        );
    }
}
